// scroll.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  private scrollToPackageSectionSource = new Subject<void>();

  scrollToPackageSection$ = this.scrollToPackageSectionSource.asObservable();

  triggerScrollToPackageSection() {
    this.scrollToPackageSectionSource.next();
  }
}